import React, { FC, ChangeEventHandler, useRef } from 'react'
import styled from 'styled-components'

import { SecondaryButton } from '../../redesign/buttons/secondaryButton'

const Input = styled.input`
    display: none;
`

interface Props {
    text: string
    onChange: ChangeEventHandler<HTMLInputElement>
}

export const FileInput: FC<Props> = ({ text, onChange }) => {
    const hiddenInputRef = useRef(null)
    const onClick = () => {
        if (!hiddenInputRef?.current) {
            return
        }

        const input = hiddenInputRef.current as HTMLInputElement
        input.click()
    }

    return (
        <>
            <Input
                ref={hiddenInputRef}
                type="file"
                multiple={true}
                onChange={onChange}
            />

            <SecondaryButton onClick={onClick}>{text}</SecondaryButton>
        </>
    )
}
